module.exports = __webpack_public_path__ + "azure.icon.a6bcf.svg";